Namespace 'Common.SimpleTabs'

class Common.SimpleTabs.SimpleTabsView extends Backbone.View
  template: JST['backbone/templates/common/simple_tabs/simple_tabs']
  className: 'simple-tabs-container'

  initialize: ({tabs = {}}) ->
    @tabs = tabs
    @tabHeaderViews = @tabs.map (tab) -> new Common.SimpleTabs.SimpleTabHeaderView tab: tab
    @tabContentViews = @tabs.map (tab) -> new Common.SimpleTabs.SimpleTabContentView tab: tab

  render: ->
    @$el.empty().append @template
    @_renderTabHeaders @$('.simple-tabs-header')
    @_renderTabContents @_tabsContentEl()
    @_activateFirstTab()
    @

  _renderTabHeaders: ($header) ->
    @tabHeaderViews.forEach (view) -> $header.append view.render().el

  _renderTabContents: ($container) ->
    @tabContentViews.forEach (view) -> $container.append view.render().el

  _activateFirstTab: ->
    @tabHeaderViews[0]?.activate()
    @tabContentViews[0]?.activate()

  showTab: (id)  =>
    tabIndex = @tabs.findIndex((tab) -> tab.id == id)
    @tabHeaderViews[tabIndex]?.activate()
    @_resetScroll()

  _resetScroll: ->
    @_tabsContentEl().scrollTop(0)

  _tabsContentEl: ->
    @$('.simple-tabs-content')

